import React from "react";
import Link from "theme/components/atoms/Typography/Link";
import LinkList from "theme/components/molecules/LinkList";
import Wysiwyg from "theme/modules/WysiwygV2";

const CategoriesMenu = ({ category }) => {
  return (
    <div className="container">
      <div className="categories-menu">
        {category.children.map((category) => (
          <div className="categories-menu__list" key={category.id}>
            <LinkList
              title={<Link to={category.path}>{category.name}</Link>}
              list={category.children}
            />
          </div>
        ))}
        <div className="categories-menu__list" key={category.id}>
          <LinkList
            title={<Link to={category.path}>See all {category.name}</Link>}
            list={[]}
          />
        </div>
        {category.descriptionWysiwyg &&
        category.descriptionWysiwyg.childNodes &&
        category.descriptionWysiwyg.childNodes.length > 0 ? (
          <div className="categories-menu__list">
            <Wysiwyg content={category.descriptionWysiwyg} />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default CategoriesMenu;
